import React, { useEffect, useState } from 'react';
import Header from '../Header';
import { saveAs } from 'file-saver';
import Table from 'react-bootstrap/Table';
import {
  getArchivedReportData,
  reportState,
  deleteReport,
  setDeleteReportDataResponse,
  getDownloadReportData,
  restoreReport,
  setRestoreReportDataResponse
} from '../../../slices/slices/ReportSlice';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import Button from '../../../components/Button';
import { ReportPath } from './common/ReportPath';

const ArchiveReport = () => {
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const { archivedReportDataResponse, deleteReportDataResponse, restoreReportDataResponse } =
    useSelector(reportState);
  const [reportId, setReportId] = useState();
  const [showDelete, setShowDelete] = useState(false);

  const delJob = (data) => {
    setShowDelete(false);
    dispatch(deleteReport(jobId, reportId, data));
    dispatch(getArchivedReportData(jobId));
  };

  const handleDelete = () => {
    setShowDelete(false);
  };

  const handleRestore = (id) => {
    dispatch(restoreReport(jobId, id));
  };

  const handleDownload = async (id) => {
    dispatch(getDownloadReportData(jobId, id)).then((res) => {
      if (res) {
        try {
          const export_report_path = ReportPath + res.data;
          var file = export_report_path.split('/');
          saveAs(export_report_path, file[file.length - 1] || 'published_report.pdf');
          // if (export_report_path) {
          //   var a = document.createElement('a');
          //   a.href = export_report_path;
          //   var file = export_report_path.split('/');
          //   a.setAttribute('download', file[file.length - 1] || 'published_report.pdf');
          //   a.setAttribute('target', '_blank');
          //   document.body.appendChild(a);
          //   a.click();
          //   a.remove();
          // }
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  // useEffect(() => {
  //   if (downloadReportDataResponse?.data) {

  //   }
  // });

  useEffect(() => {
    if (restoreReportDataResponse?.message) {
      setShowDelete(false);
      dispatch(getArchivedReportData(jobId));
      dispatch(setRestoreReportDataResponse({}));
    }
  }, [restoreReportDataResponse?.message]);

  useEffect(() => {
    if (deleteReportDataResponse?.message) {
      setShowDelete(false);
      dispatch(getArchivedReportData(jobId));
      dispatch(setDeleteReportDataResponse({}));
    }
  }, [deleteReportDataResponse?.message]);

  useEffect(() => {
    dispatch(getArchivedReportData(jobId));
  }, []);

  return (
    <div className="dashboard toggle-sidebar">
      <Header />
      <div id="main" className="main">
        <div className="group-breadcrumb d-flex justify-content-between align-items-center">
          <div className="breadcrumb-left">
            <ul>
              <li>
                <a href="#">Group Reports</a>
              </li>
              <li>
                <strong>Archived Reports</strong>
              </li>
            </ul>
          </div>
        </div>
        <div className="pagetitle proversion">
          <div className="title_pro d-flex justify-content-between align-items-center">
            <h1>Archived Reports</h1>
          </div>
        </div>
        <div className="white-card">
          <Table className="table table-hover">
            <thead>
              <tr>
                <th scope="col" className="text-start">
                  Job Name
                </th>
                <th scope="col" className="text-start">
                  Report Type
                </th>
                <th scope="col" className="text-start">
                  Published By
                </th>
                <th scope="col" className="text-start">
                  Date Created
                </th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {archivedReportDataResponse && archivedReportDataResponse?.length > 0 ? (
                archivedReportDataResponse?.map((item) => {
                  return (
                    <tr key={item?.id}>
                      <td className="text-start">{item?.job?.name}</td>
                      <td className="text-start">{item?.report_type}</td>
                      <td className="text-start">{item?.published_by}</td>
                      <td className="text-start">
                        {moment(item?.created_at).format('DD/MM/YYYY HH:mm:ss A')}
                      </td>
                      <td>
                        {item?.path ? (
                          <ul className="action-btn">
                            {/* <li>
                            <Button>
                              <i className="fa fa-file-alt"></i>
                            </Button>
                          </li> */}
                            <li>
                              <Button
                                onClick={() => {
                                  setReportId(item?.id);
                                  handleDownload(item?.id);
                                }}
                              >
                                <i className="fa fa-download"></i>
                              </Button>
                            </li>
                            {/* <li>
                            <Button>
                              <i className="fa fa-print"></i>
                            </Button>
                          </li> */}
                            <li>
                              <Button
                                onClick={() => {
                                  setReportId(item?.id);
                                  handleRestore(item?.id);
                                }}
                              >
                                <i className="fa fa-file-export"></i>
                              </Button>
                            </li>
                            <li>
                              <Button
                                onClick={() => {
                                  setReportId(item?.id);
                                  setShowDelete(true);
                                }}
                              >
                                <i className="fa fa-trash-alt"></i>
                              </Button>
                            </li>
                          </ul>
                        ) : item?.report_status === 3 ? (
                          'Error while creating'
                        ) : item?.report_status === 1 ? (
                          'In Progress'
                        ) : (
                          'Not Started'
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">No Records Found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal
        show={showDelete}
        onHide={handleDelete}
        dialogClassName="modal-50w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <h2>Delete Job?</h2>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this job?</p>
        </Modal.Body>
        <div className="modal-action modal-footer">
          <Button className="btn btn-secondary" onClick={handleDelete}>
            Cancel
          </Button>
          <Button
            className="btn btn-primary"
            onClick={() => {
              delJob({ report_type: 'archive' });
            }}
          >
            Delete
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ArchiveReport;
